import React from 'react';

// import i18n from '../../i18n';
// import PropTypes from 'prop-types';
import Select from 'react-select';
import styles from './Dropdown.module.scss';
import classNames from 'classnames';

const Dropdown = ({ options, onChange, value }) => {
    return (
        <div className={styles['Dropdown']}>
            <Select
                options={options}
                value={value}
                onChange={onChange}
                classNames={{
                    control: ({ isFocused, selectProps }) =>
                        classNames(styles.SelectControl, {
                            [styles['SelectControl--IsFocused']]: isFocused,
                            [styles['SelectControl--IsMenuOpened']]:
                                selectProps.menuIsOpen,
                        }),
                    input: () => styles.SelectInput,
                    singleValue: () => styles.SelectSingleValue,
                    option: ({ isSelected, isFocused }) => {
                        return classNames(styles.Option, {
                            [styles['Option--IsSelected']]: isSelected,
                            [styles['Option--IsFocused']]: isFocused,
                        });
                    },
                    menuList: () => styles.MenuList,
                    noOptionsMessage: () => styles.SelectNoOptionsMessage,
                    menu: () => styles.Menu,
                    placeholder: () => styles.Placeholder,
                    clearIndicator: () => styles.ClearIndicator,
                    dropdownIndicator: () => styles.DropdownIndicator,
                    indicatorSeparator: () => styles.IndicatorSeparator,
                }}
            />
        </div>
    );
};

Dropdown.propTypes = {};

export default Dropdown;
